const prettyPrintJson = (json: object) => JSON.stringify(json, null, 2);

export default prettyPrintJson;
